<template>
  <div v-if="!loading">
    <img
      v-if="brokerLogo"
      class="mx-auto mt-8 hidden h-11 w-auto md:block"
      :src="brokerLogo"
      alt="broker logo"
    />
    <do-not-dispatch
      :broker-logo="brokerLogo"
      :company-type="companyType"
      :company-name="companyName"
      :support-email="supportEmail"
    />
  </div>
  <div
    v-else
    class="tablet-desktop-container mx-auto flex h-80 max-w-2xl items-center justify-center overflow-scroll pt-12 md:overflow-hidden"
  >
    <img
      class="-top-2px loading relative h-12 w-full"
      src="@/assets/loading-v2-yellow.svg"
      alt=""
    />
  </div>
</template>
<script>
import DoNotDispatch from '@/components/holding-tanks/DoNotDispatch.vue';
export default {
  name: 'Do Not Dispatch Holding Tank',
  components: {
    DoNotDispatch,
  },
  data() {
    return {};
  },
  computed: {
    companyType() {
      return this.$store.state.users.currentUser.company.company_type;
    },
    companyName() {
      return this.$store.state.users.currentUser.company.legal_name;
    },
    brokerLogo() {
      return this.$store.state.company?.company?.logo?.url || null;
    },
    loading() {
      return this.$store.state.loading.isLoading;
    },
    supportEmail() {
      return this.$store.state.company.company.support_email;
    },
  },
  watch: {
    '$store.state.company.company': function (val) {
      if (Object.keys(val).length > 0) {
        this.$store.commit('loading/loadingToggleOff', null, {
          root: true,
        });
      }
    },
  },
  async created() {
    this.$store.commit('loading/loadingToggleOn', null, {
      root: true,
    });
    await this.$store.dispatch(
      'company/getCompanyByClientId',
      localStorage.getItem('client_id')
    );
  },
};
</script>
